import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://nhuxbrlbzrulbncghtim.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_zh1_erTv_WxjJIJiyhYRdw_rVkVgoIz";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
